import { client, gql } from './Client';

const taskAuditQuery = gql`
  query taskAuditInfoById($taskId: Int!) {
    taskAuditInfoById(taskId: $taskId) {
      action
      actionDate
      field
      newValue
      oldValue
      userName
      userRole
    }
  }
`;

const deficiencyAuditQuery = gql`
  query deficiencyAuditInfoById($deficiencyId: Int!, $inspectionId: Int!) {
    deficiencyAuditInfoById(deficiencyId: $deficiencyId, inspectionId: $inspectionId) {
      action
      actionDate
      field
      newValue
      oldValue
      userName
      userRole
      inspectionId
    }
  }
`;

const taskAudit = (taskId: number) =>
  client.query({ query: taskAuditQuery, variables: { taskId } });

const deficiencyAudit = (deficiencyId: number, inspectionId = 0) =>
  client.query({ query: deficiencyAuditQuery, variables: { deficiencyId, inspectionId } });

export { deficiencyAudit, taskAudit };
